import _ from 'lodash';
import angular from 'angular';
import template from './template.html';
import { Inject } from '../../../base/decorators';
import BaseComponent from '../../../base/component';
import { RECRUITER_WORKFLOW_STATUS } from '../../constants/recruiter-workflow';
import './style.scss';

export class RecruiterCandidatePage extends BaseComponent {
    @Inject('$stateParams') $stateParams;
    @Inject('ImpersonationService') impersonationService;
    @Inject('$timeout') $timeout;
    @Inject('EMPLOYER_WORKFLOW_STATUS') EMPLOYER_WORKFLOW_STATUS;
    @Inject('WorkflowService') workflowService;

    $onInit(...args) {
        super.$onInit(...args);
        this.$scope.searchCtrl = this.searchCtrl;
        this.$scope.EMPLOYER_WORKFLOW_STATUS = this.EMPLOYER_WORKFLOW_STATUS;
    }

    async setupComponentData() {
        this.currentRecruiter = await this.impersonationService.getBehalfOfOrCurrentTalentExpertRoleData();
    }

    $onChanges() {
        const { searchCtrl, $stateParams } = this;

        this.isActionButtonVisible = this.getActionButtonVisibleState(searchCtrl);
        this.isAssociatedRecruiterLabelVisible = this.getAssociatedRecruiterLabelVisibleState($stateParams.workflowStep);
    }

    getActionButtonVisibleState(searchCtrl) {
        return true;
    }

    getAssociatedRecruiterLabelVisibleState(currentWorkflow) {
        return currentWorkflow === RECRUITER_WORKFLOW_STATUS.FEEDBACK;
    }
}

export const RecruiterCandidatePageConfiguration = {
    template,
    controller: RecruiterCandidatePage,
    bindings: {},
    require: {
        searchCtrl: '^searchComponent',
    },
    controllerAs: 'recruiterCandidatePageCtrl',
};

angular.module('TALENYA-FE').component('recruiterCandidatePage', RecruiterCandidatePageConfiguration);
